import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { Box } from "../Box/Box.mjs";
import { FieldOverlay } from "../private/FieldOverlay/FieldOverlay.mjs";
import { root, hoverOverlay, focusOverlay } from "./Pressable.css.mjs";
const Pressable = ({
  id,
  borderRadius,
  tabIndex = 0,
  children,
  disabled,
  onClick,
  "aria-describedby": ariaDescribedBy
}) => {
  const buttonRef = useRef(null);
  const handleKeyboard = (e) => {
    var _a;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      (_a = buttonRef.current) == null ? void 0 : _a.click();
    }
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      role: "button",
      ref: buttonRef,
      id,
      position: "relative",
      tabIndex: disabled ? -1 : tabIndex,
      cursor: disabled ? "default" : "pointer",
      onClick: disabled ? void 0 : onClick,
      onKeyDown: disabled ? void 0 : handleKeyboard,
      "aria-describedby": ariaDescribedBy,
      disabled,
      "aria-disabled": disabled,
      className: root,
      children: [
        !disabled && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(FieldOverlay, { variant: "hover", borderRadius, className: hoverOverlay }),
          /* @__PURE__ */ jsx(FieldOverlay, { variant: "focus", borderRadius, className: focusOverlay })
        ] }),
        children
      ]
    }
  );
};
Pressable.displayName = "Pressable";
export {
  Pressable
};
